import React from "react";
import { hideDiscountInfo } from "../../../../../../../common-deprecated/priceUtils";
import PricePromoIcon from "./PricePromoIcon";
import * as Styles from "./styles/CashPrice";
import { BnbLabel } from "../../../../utils/labels";
import {
    formatAEMCashPrice,
    formatAEMCashPriceIsrael,
} from "../../../../../../../common-deprecated/settings/utils/financeSettingUtilsAem";
import Popover from "../../../../../../../common-deprecated/components/popover/aem/Popover";
import type { CashPriceType } from "./CashPrice";

const CashPriceIsrael = (props: CashPriceType): JSX.Element | null => {
    const { price, priceConfig, cultureName, small, isLarge, showLoader, cashPriceDisclaimer } = props;
    const { highlight, discount, cash, promotions, licenseFee } = price;

    if (!price.cash || !priceConfig.priceEnabled) return null;

    const hideDiscount = hideDiscountInfo(priceConfig);
    if (showLoader)
        return (
            <Styles.Text isLarge={!!isLarge} isSmall={small}>
                <BnbLabel label="priceLoading" fallbackLabel="spinLoading" />
            </Styles.Text>
        );

    // Highlight is also a type of promotion which does not alter the price but should show the text as highlighted.
    if ((highlight || discount !== cash || promotions.length > 0) && !hideDiscount) {
        const cashFormatted = formatAEMCashPrice(cash, cultureName, priceConfig);
        const discountFormatted = formatAEMCashPrice(discount, cultureName, priceConfig, licenseFee);
        return (
            <Styles.PricesWrapper>
                <div>
                    <Styles.Text
                        dangerouslySetInnerHTML={{ __html: discountFormatted }}
                        isLarge={!small && (discount !== cash || promotions.length > 0)}
                        isSmall={small}
                    />
                    {promotions.length > 0 && <PricePromoIcon promotions={promotions} />}
                </div>

                {!highlight && discount !== cash && (
                    <Styles.TextLineThrough dangerouslySetInnerHTML={{ __html: cashFormatted }} isSmall={!!small} />
                )}
            </Styles.PricesWrapper>
        );
    }

    const cashFormatted = formatAEMCashPriceIsrael(
        hideDiscountInfo(priceConfig) ? discount : cash,
        cultureName,
        priceConfig,
        licenseFee,
        false,
    );

    return (
        <Styles.PricesWrapper>
            <Styles.Text isLarge={!!isLarge} isSmall={small}>
                {cashFormatted.map((value, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <span key={index}>
                        <Styles.SpanText dangerouslySetInnerHTML={{ __html: value }} />
                        {/* Only render the disclaimer when there are more then 1 span elements and when a disclaimer is available. */}
                        {cashPriceDisclaimer && index === cashFormatted.length - 1 && cashFormatted.length > 1 && (
                            <Popover iconColor="primaryBlack" showOnClick content={cashPriceDisclaimer} useHTML />
                        )}
                    </span>
                ))}
            </Styles.Text>
        </Styles.PricesWrapper>
    );
};

export default CashPriceIsrael;
